import React, { useCallback } from 'react';
import { useStore } from 'react-redux';

import {
  updateDuplicateIdAction,
  updateErrorAction,
  updateRuleAction,
  updateStageAction,
} from 'app-components/flux/transaction-rules/transactionRuleActions';
import { clearState } from 'app-components/flux/transaction-rules/transactionRulesForm';
import { FormProvider } from 'app-components/flux/transaction-rules/transactionRulesFormHooks';
import { useStateContext } from 'app-components/flux/transaction-rules/transactionRulesFormState';
import { getDuplicateRuleId } from 'app-components/flux/transaction-rules/transactionRulesSelectors';
import type { SubmitHandler, SubmitPayload } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import { VALIDATED } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import { checkRuleConditions } from 'app-components/flux/transaction-rules/transactionRulesUtils';

import FormContainer from './FormContainer';

const RuleContainer: React.FC = () => {
  const { state, dispatch } = useStateContext();
  const store = useStore();

  // recieves vales from the formBuilder form and updates the rule, error and stage in the context.  This is only called if field-level vadiation passed
  const onSubmit: SubmitHandler<SubmitPayload, boolean> = useCallback(
    async ({ payload }: { payload: SubmitPayload }) => {
      const { transactionRule } = payload;

      if (transactionRule) {
        // update the rule in the context based on the form submit values
        dispatch(updateRuleAction(transactionRule));

        // update or clear error
        const error = checkRuleConditions(payload);
        dispatch(updateErrorAction(error));
        if (error) {
          return;
        }

        // update or clear duplicateId
        const duplicateId = getDuplicateRuleId(store.getState(), transactionRule);
        dispatch(updateDuplicateIdAction(duplicateId));
        if (duplicateId) {
          return;
        }

        // update stage based on errors & duplicate checks
        dispatch(updateStageAction(VALIDATED));
      }
    },
    [dispatch, store],
  );

  return (
    <>
      <FormProvider input={state.rule || clearState} onSubmit={onSubmit}>
        <FormContainer />
      </FormProvider>
    </>
  );
};

export default RuleContainer;
